import config from "../config";

const baseUrl = config.base_url + "farmBasicInfo/";

export default {
  // 农场列表分页查询，支持按区县筛选（district 为区县名称或区县代码）
  page: {
    url: baseUrl + "page/{limit}/{page}",
    type: "get",
  },
  // 区县下拉列表（id 为区县代码，name 为区县名称）
  districtOptions: {
    url: baseUrl + "districtOptions",
    type: "get",
  },
  // 荔枝品种种植面积统计（环形图），query district 可选，传「全部区」或空为全市
  statVarietyArea: {
    url: baseUrl + "stat/varietyArea",
    type: "get",
  },
  // 荔枝种植面积分区统计（环形图）
  statAreaByDistrict: {
    url: baseUrl + "stat/areaByDistrict",
    type: "get",
  },
  // 农机设备分区统计（柱状图）
  statMachinery: {
    url: baseUrl + "stat/machinery",
    type: "get",
  },
  // 人力资源分区统计（柱状图）
  statHumanResource: {
    url: baseUrl + "stat/humanResource",
    type: "get",
  },
};
